import { render, staticRenderFns } from "./BsListNav.vue?vue&type=template&id=5b6dd41a&"
import script from "./BsListNav.vue?vue&type=script&lang=js&"
export * from "./BsListNav.vue?vue&type=script&lang=js&"
import style0 from "./BsListNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports